<template>
  <el-row :gutter="20" type="flex" align="middle" class="ship-route-action">
    <el-col
      ref="dayMenu"
      v-hidelast="{ action: handleResize, trigger: isCollapse }"
      :span="22"
      class="ra_col"
    >
      <div
        v-for="(item, i) in items"
        :id="`${item.icon}_${bid.id}`"
        :key="i"
        class="ra_col_item"
      >
        <template v-if="item.command !== 'setPaid'">
          <i v-if="item.icon" :class="`el-icon-${item.icon}`" />
          <span @click="handleCommand(item.command)">
            {{ getText(item) }}
          </span>
        </template>
        <template v-else>
          <el-switch
            v-model="isPaid"
            active-color="#409eff"
            inactive-color="#cccccc"
            active-text="Оплачено"
            :active-value="1"
            @change="setPaid(bid.id)"
          />
        </template>
      </div>
    </el-col>
    <el-col :span="2" class="ta-r">
      <el-dropdown
        v-if="itemsHidden.length"
        trigger="click"
        @command="handleCommand"
      >
        <el-button size="mini" icon="el-icon-more" circle />
        <el-dropdown-menu slot="dropdown" class="bid-dropdown">
          <el-dropdown-item
            v-for="(item, i) in itemsHidden"
            :key="i"
            :icon="`el-icon-${item.icon}`"
            :command="item.command"
          >
            {{ getText(item) }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE } from '@/store/actions/loadDay'
import { dayMenuItems, dayMenuItemsHidden } from './constants'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'BidActions',
  directives: {
    hidelast: {
      componentUpdated(el, binding) {
        const { value } = binding

        if (value.trigger) {
          value.action()
        }
      },
    },
  },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    choosed: {
      type: Array,
      default: () => [],
    },
    isArchive: {
      type: Boolean,
      default: false,
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
    daysBefore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: this.getItems(dayMenuItems),
      itemsHidden: this.getItems(dayMenuItemsHidden),
      isPaid: false,
    }
  },
  computed: {
    count() {
      return this.choosed.length
    },
  },
  watch: {
    isCollapse(val) {
      return val ? this.addEvent() : this.delEvent()
    },
  },
  mounted() {
    this.isPaid = this.bid.is_paid
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    addEvent() {
      this.$nextTick(() => window.addEventListener('resize', this.handleResize))
    },
    delEvent() {
      this.$nextTick(() =>
        window.removeEventListener('resize', this.handleResize),
      )
    },
    handleCommand({ func, type }) {
      this[func](type)
    },
    getItems(items) {
      return items.filter(i => this.showDayMenuItem(i))
    },
    showDayMenuItem(item) {
      return !item.action || this.canAction(item.action)
    },
    getText(item) {
      return item.getText(this[item.param])
    },
    showDaysBefore() {
      this.$emit('show')
    },
    editRegistry() {
      this.$emit('editRegistry', this.bid)
    },
    setBid(type) {
      this.$emit('set', this.bid, type)
    },
    addBidToLP() {
      const { id, show_on_landing } = this.bid

      this.$emit('addBidToLP', { id, show_on_landing: !show_on_landing })
    },
    onReport() {
      const load_days_ids = this.choosed

      if (load_days_ids.length) {
        this.$emit('report', load_days_ids)
      } else {
        this.$message.warning('Не выбран ни один день')
      }
    },
    setHot() {
      const { id, hot } = this.bid

      this.$emit('setHot', { id, hot: !hot })
    },
    onGenerateReportModalHandler() {
      const load_days_ids = this.choosed

      if (load_days_ids.length) {
        this.$emit('openDialogGenerateReport', load_days_ids)
      } else {
        this.$message.warning('Не выбран ни один день')
      }
    },
    toArchive() {
      if (this.bid.id) {
        const body = this.isArchive
          ? { archive_date: null }
          : { to_archive: '1' }

        Bids.putBids(this.bid.id, body)
          .then(res => {
            const { status, data } = res

            if (status === 200) {
              this.$emit('fetch')
              this.$message({
                message: `Перевозка №${data.id} ${
                  this.isArchive ? 'раз' : 'за'
                }архивирована`,
                type: 'success',
              })
            }
          })
          .catch(err => this.errHandler(err))
      }
    },
    onPaymentBankModalHandler() {
      this.$emit('openPaymentsBanksModal', {
        curBidId: this.bid.id,
        load_days_ids: this.choosed,
      })
    },
    onDownloadReport() {
      this.$store.dispatch(
        `loadDay/${SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE}`,
        true,
      )
      this.$emit('openDialogSaveNomenclature', this.bid.id)
    },
    async handleResize() {
      const navMenuRight =
        this.$refs['dayMenu']?.$el.getBoundingClientRect().right
      const lastItem = this.items[this.items.length - 1]
      const el = lastItem ? `${lastItem.icon}_${this.bid.id}` : ''
      const target = document.getElementById(el)

      if (target) {
        const lastItemRight = target.getBoundingClientRect().right

        if (lastItemRight > navMenuRight) {
          await this.items.pop()
          this.itemsHidden.unshift(lastItem)
        } else if (navMenuRight - lastItemRight > 220) {
          const firstItem = this.itemsHidden[0]

          if (firstItem) {
            this.itemsHidden.shift()
            this.items.push(firstItem)
          }
        }
      }
    },
    setPaid(id) {
      this.$nextTick(() => this.$emit('set-paid', id))
    },
  },
}
</script>

<style lang="sass">
.ship-route-action
  margin-top: 40px
  .ra_col
    display: flex
  .ra_col_item
    display: flex
    margin-right: 25px
    i
      font-size: 23px
      margin-right: 10px
    span
      color: #409EFF
      font-size: 14px
      white-space: nowrap
      &:hover
        cursor: pointer
        text-decoration: underline
  i.el-icon-more
    font-size: 20px
    margin: 0
.bid-dropdown
  .el-dropdown-menu__item
    text-transform: uppercase
</style>
